import useFetch from '../../../../elements/Hooks/useFetch'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import ContractsApi from '../../../../api/Finance/LenderContracts'
import LendersAPI from '../../../../api/Finance/Lenders'
import Members from '../../../../api/Members'
import ViewContract from '../../../../components/Finance/Lender/ViewContract/ViewContract'
import useActions from '../../../../elements/Hooks/useActions'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { get, isEmpty, pick } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'
const lenderApi = new LendersAPI()
const contractApi = new ContractsApi()
const memberApi = new Members()

function ViewContractCont(props) {
  const key = props.match.params.key
  const contractKey = get(props.match, 'params.contractKey')

  const { data: member, fetching } = useFetch({
    url: 'members/' + key,
    dependencyArray: [key],
    dontFetch: isEmpty(key),
  })

  const [removing, removeFunc] = useSubmit(contractApi.remove)

  const { object: contract, setObject: setContract, fetch } = useFetchObject(() => contractApi.get(contractKey))

  async function remove() {
    const removed = await removeFunc({
      ...pick(contract, ['_key', '_rev', '_id']),
    })
    fetch()
    if (removed)
      props.history.replace({
        pathname: `/finance/lenders/${key}`,
      })
  }
  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'lenderContracts',
    contract,
    setContract,
    lenderApi.contracts.operation
  )

  return (
    <ViewContract
      {...{
        key,
        contract,
        member,
        remove,
        fetching,
        actions,
        contractKey,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
        fetch,
      }}
    />
  )
}

export default withRouter(ViewContractCont)
